import router from '@/router'
import api, { getData } from '@/axiosConfig'
import {
  status,
  defaultNotFoundImage,
  compare,
  recipientListFilterTypes
} from '../../helpers'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'
import requestErrorHandler from '@/utils/request-error-handler'

import {
  CREATING_GROUP_ORDER,
  LOAD_GROUP_ORDER_PRODUCTS,
  SET_GROUP_ORDER_PRODUCTS,
  LOAD_GROUP_ORDER,
  SET_GROUP_ORDER_DETAILS,
  SET_GROUP_ORDER_TIERS,
  ADD_NEW_TIER_TO_GROUP_ORDER,
  SAVE_TEMP_GROUP_ORDER_TIER,
  UPDATE_GROUP_ORDER_TIER,
  RESTORE_TEMP_GROUP_ORDER_TIER,
  REMOVE_GROUP_ORDER_TIER,
  MARK_TEMPORALY_TIER_ITEM,
  SET_UPDATING_TIER_ITEMS,
  CLEAR_TEMPORALY_TIER_ITEMS,
  ADD_NEW_ITEM_TO_TIER,
  SAVE_TEMP_ITEM_TO_REMOVE,
  CLEAR_TEMP_ITEM_TO_REMOVE,
  RESTORE_TEMP_ITEM_TO_REMOVE,
  REMOVE_ITEM_FROM_TIER,
  RESET_TIER_ITEMS_TO_REMOVE,
  UNMARK_TEMPORALY_TIER_ITEM,
  SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS,
  UPDATING_GROUP_ORDER_PASSWORD,
  LOAD_GROUP_ORDERS_LIST,
  LOAD_GROUP_ORDER_ITEMS_ORDERED,
  SET_GROUP_ORDER_ITEMS_ORDERED,
  LOAD_GROUP_ORDER_RECIPIENTS_LIST,
  SET_GROUP_ORDER_RECIPIENT_LIST,
  SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST,
  SET_GROUP_ORDERS_LIST,
  LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS,
  SET_RECIPIENTS_SELECTED_ITEMS,
  IS_FINALIZING_GROUP_ORDER,
  ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO,
  REMOVE_RECIPIENT_FROM_GROUP_ORDER,
  CLEAN_RECIPIENTS_LIST_TO_REMOVE,
  LOAD_GROUP_ORDER_INFO,
  VALIDATING_GROUP_ORDER_RECIPIENT,
  SET_GROUP_ORDER_RECIPIENT,
  LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT,
  SET_SELECTABLE_GROUP_ORDER_TIERS,
  SET_CURRENT_ITEMS_SELECTED,
  ACTIVATE_ITEM,
  DEACTIVATE_ITEM,
  ADD_NEW_ITEM_TO_RECIPIENT_SELECTION,
  SET_REALID_TO_ITEM_RECIPIENT_SELECTION,
  REMOVE_TEMP_ITEM_RECIPIENT_SELECTION,
  REMOVE_ITEM_FROM_RECIPIENT_SELECTION,
  SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  UPDATING_GROUP_ORDER_RECIPIENT,
  CONFIRM_RECIPIENT_GROUP_ORDER,
  IS_CONFIRMING_GROUP_ORDER,
  RESET_GROUP_ORDER_STATE,
  SET_CARD_MESSAGE,
  SET_SELECTED_TEMPLATE,
  HANDLE_VARIANT_SELECTION,
  SET_ORDERSTORE_PAGINATION_TOTAL_COUNT,
  SET_RECIPIENT_PAGINATION,
  SET_GROUP_ORDER_STATE,
  GETTING_SHIPPING_DETAILS,
  LOAD_ALLOW_LIST,
  SET_ALLOW_LIST,
  REMOVED_ALL_USERS_FROM_ALLOW_LIST,
  ALLOW_LIST_UPLOADED,
  VERIFICATION_EMAIL_STATUS,
  REDEMPTION_UUID,
  LOAD_ALLOW_LIST_ECOMMERCE,
  SET_ALLOW_LIST_ECOMMERCE,
  UPDATING_AUTO_FINALIZING,
  CREATING_GROUP_ORDER_STEP
} from '@/state/mutationTypes'

export default {
  async uploadAllowList(
    { commit, dispatch },
    { type, id, selectedLists, file }
  ) {
    try {
      commit(LOAD_ALLOW_LIST, true)
      let response = ''
      if (type === 'list') {
        response = await gemnoteAPI.post(
          `/team/group_orders/${id}/group_order_allow_lists
        `,
          {
            group_order_allow_list: {
              recipient_list_ids: selectedLists
            }
          }
        )
      } else {
        const formData = new FormData()
        formData.append('group_order[allowed_users_file]', file)
        response = await gemnoteAPI.post(
          `/team/group_orders/${id}/group_order_allow_lists/upload_allowed_users
        `,
          formData
        )
      }

      if (response.status === 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.upload-allow-list-success')]
          },
          { root: true }
        )

        dispatch('loadAllowList', id)
        commit(ALLOW_LIST_UPLOADED, true)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST, false)
    }
  },
  async uploadAllowListEcommerce({ commit, dispatch }, { type, email, file }) {
    try {
      // commit(LOAD_ALLOW_LIST, true)
      let response = ''
      if (type === 'list') {
        response = await gemnoteAPI.post(
          `/allowed_users
        `,
          {
            allowed_user: {
              email: email
            }
          }
        )
      } else {
        const formData = new FormData()
        formData.append('upload_file', file)
        response = await gemnoteAPI.post(
          `/allowed_lists
        `,
          formData
        )
      }

      if (response.status === 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.upload-allow-list-success')]
          },
          { root: true }
        )

        dispatch('loadAllowListEcommerce')
        dispatch('recipient/loadRecipientList', '', { root: true })
        dispatch('recipient/loadEcommerceRecipientList', '', { root: true })
        commit(ALLOW_LIST_UPLOADED, true)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      // commit(LOAD_ALLOW_LIST, false)
    }
  },
  async loadAllowList({ commit }, id) {
    try {
      commit(LOAD_ALLOW_LIST, true)
      const response = await gemnoteAPI.get(
        `/team/group_orders/${id}/group_order_allow_lists`
      )

      const data = getData(response).attributes
        ? getData(response).attributes.allowedUserDetails
        : []

      if (response.status === 200) {
        commit(SET_ALLOW_LIST, data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST, false)
    }
  },
  async loadAllowListEcommerce({ commit }) {
    try {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, true)
      const response = await gemnoteAPI.get('allowed_users')

      const data = response.data

      if (response.status === 200) {
        commit(SET_ALLOW_LIST_ECOMMERCE, data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, false)
    }
  },
  async addSingleEmail({ commit, dispatch }, { id, email }) {
    try {
      commit(LOAD_ALLOW_LIST, true)

      const response = await gemnoteAPI.post(
        `team/group_orders/${id}/group_order_allowed_users`,
        {
          group_order_allowed_user: {
            email: email
          }
        }
      )

      if (response.status === 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.single-user-added-success')]
          },
          { root: true }
        )

        dispatch('loadAllowList', id)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST, false)
    }
  },
  async removeAllowedEmail({ commit, dispatch }, { groupOrderId, userId }) {
    try {
      commit(LOAD_ALLOW_LIST, true)

      const response = await gemnoteAPI.patch(
        `/team/group_orders/${groupOrderId}/group_order_allowed_users/${userId}`
      )

      if (response.status === 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.remove-allowed-user')]
          },
          { root: true }
        )

        dispatch('loadAllowList', groupOrderId)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST, false)
    }
  },
  async removeSingleAllowedEmailEcommerce({ commit, dispatch }, { userId }) {
    try {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, true)

      const response = await gemnoteAPI.delete(`/allowed_users/${userId}`)

      if (response.status === 200) {
        dispatch('recipient/loadEcommerceRecipientList', '', { root: true })
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.remove-allowed-user')]
          },
          { root: true }
        )

        dispatch('loadAllowListEcommerce')
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, false)
    }
  },
  async removeAllowedEmailEcommerce({ commit, dispatch }, { id }) {
    try {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, true)

      const response = await gemnoteAPI.delete(`/allowed_lists/bulk_delete`, {
        data: {
          allow_list: {
            ids: id
          }
        }
      })

      if (response.status === 200) {
        dispatch('recipient/loadEcommerceRecipientList', '', { root: true })
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.remove-allowed-user')]
          },
          { root: true }
        )

        dispatch('loadAllowListEcommerce')
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST_ECOMMERCE, false)
    }
  },

  async removeAllUsers({ commit, dispatch }, { id, payload }) {
    try {
      commit(LOAD_ALLOW_LIST, true)
      const response = await gemnoteAPI.post(
        `/team/group_orders/${id}/group_order_allowed_users/bulk_delete`,
        {
          group_order_allowed_users: {
            ids: payload
          }
        }
      )

      if (response.status === 200) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('grouporder.action.remove-allowed-email')]
          },
          { root: true }
        )

        dispatch('loadAllowList', id)
        commit(REMOVED_ALL_USERS_FROM_ALLOW_LIST, true)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(LOAD_ALLOW_LIST, false)
    }
  },

  setCardMessage({ commit }, cardMessage) {
    commit(SET_CARD_MESSAGE, cardMessage)
  },

  setSelectedTemplate({ commit }, selectedTemplateId) {
    commit(SET_SELECTED_TEMPLATE, selectedTemplateId)
  },
  async addCard({ dispatch }, data) {
    try {
      const response = await gemnoteAPI.post(
        `team/group_orders/${data.id}/add_cards`,
        {
          group_order: {
            cards: [
              { product_variant_id: data.productId, quantity: data.quantity }
            ]
          }
        }
      )

      if (response.status === 200) {
        router.push({
          name: data.isEdit ? 'EditGroupOrderInfo' : 'GroupOrderInfo',
          params: { id: data.id, isEdit: data.isEdit }
        })
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.gorder-startautofinalize-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrderGallery({ commit, dispatch }) {
    try {
      commit(LOAD_GROUP_ORDER_PRODUCTS, status.LOADING)
      let response
      let combinedProducts = []

      response = await gemnoteAPI.get(`team/products`)
      let products = getData(response)
      combinedProducts = products.map(product => {
        return {
          id: parseInt(product.id),
          attributes: product.attributes,
          type: product.type
        }
      })

      response = await gemnoteAPI.get(`team/bundles`)
      let bundles = getData(response)

      bundles.map(bundle => {
        combinedProducts.push({
          id: parseInt(bundle.id),
          attributes: bundle.attributes,
          type: bundle.type
        })
      })

      commit(SET_GROUP_ORDER_PRODUCTS, combinedProducts)
      commit(LOAD_GROUP_ORDER_PRODUCTS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER_PRODUCTS, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('grouporder.action.load-gorder-gallery-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async createGroupOrder(
    { commit, dispatch },
    { name, showPrices, selectionType, autoFinalize }
  ) {
    try {
      let errors = []
      if (!name || name.trim() === '') {
        errors.push(i18n.t('validations.blank-grouporder-name'))
      }

      if (errors.length) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        return
      }
      commit(CREATING_GROUP_ORDER, true)
      let body = {
        name,
        password: null,
        password_protected: false,
        company_email_limited: false,
        show_prices: showPrices
      }

      let response = await gemnoteAPI.post('team/group_orders', body)
      const groupOrder = getData(response)

      // create firts tier as default
      body = {
        name: '',
        gifts_limit: 1,
        selection_type: selectionType
      }

      response = await gemnoteAPI.post(
        `team/group_orders/${groupOrder.id}/group_order_tiers`,
        body
      )
      commit(CREATING_GROUP_ORDER, false)
      commit(SET_GROUP_ORDER_DETAILS, groupOrder)

      // start auto finalizing if auto finalize toggle is checked
      if (autoFinalize) {
        await dispatch('startInstantFinalize', groupOrder.id)
      }
      commit(CREATING_GROUP_ORDER_STEP, 2)
      // router.push({
      //   name: 'GroupOrderItemsSelection',
      //   params: { id: groupOrder.id }
      // })
    } catch (error) {
      console.log(error)
      commit(CREATING_GROUP_ORDER, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.create-gorder-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrder({ commit, dispatch }, groupOrderId) {
    try {
      // GET group order details
      commit(LOAD_GROUP_ORDER, status.LOADING)
      let response = await gemnoteAPI.get(`team/group_orders/${groupOrderId}`)

      let data = getData(response)
      let groupOrderDetails = {
        id: data.id,
        cardsBlob: data && data.cardsBlob ? data.cardsBlob : {},
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }

      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)

      // GET group order tiers
      await dispatch('getGroupOrderTiers', groupOrderId)
      commit(LOAD_GROUP_ORDER, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
          router.push({ name: 'notfound' })
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-details-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrderTiers({ commit, dispatch }, groupOrderId) {
    try {
      // GET group order tiers details
      let response = await gemnoteAPI.get(
        `team/group_orders/${groupOrderId}/group_order_tiers`
      )
      let data = getData(response)
      // If there are tiers already created we just loop tru and commit the existing tiers
      let groupOrderTiers = data.map(tier => {
        const defaultTiers = tier.attributes.tierItemDetails
        return {
          id: parseInt(tier.id),
          name: tier.attributes.name,
          tierQuantityLimit: `${tier.attributes.giftsLimit}`,
          tierItems: tier.attributes.tierItemDetails,
          defaultTiers: defaultTiers,
          componentType: 'GroupOrderGallery',
          editable: tier.attributes['editable?'],
          selectionType: tier.attributes.selectionType
        }
      })
      commit(SET_GROUP_ORDER_TIERS, groupOrderTiers)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
          router.push({ name: 'notfound' })
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-get-tiers-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateGroupOrder(
    { commit, dispatch, state },
    {
      password,
      redemptionTitle,
      redemptionDescription,
      customFields,
      redirect,
      showPrices,
      enableCustomTitle,
      enableCustomSubTitle,
      enableCustomDescription,
      passwordProtected,
      redemptionSubTitle,
      allowedDomains,
      EmailVerified,
      cardMessage,
      name,
      autoFinalize
    }
  ) {
    try {
      if (!redirect) commit(UPDATING_GROUP_ORDER_PASSWORD, true)
      let { groupOrderDetails } = state
      let body = {
        name: name || groupOrderDetails.name,
        password: password,
        password_protected: passwordProtected,
        company_email_limited: false,
        custom_fields: customFields
          ? customFields.filter(field => field.name.trim() !== '')
          : '',
        show_prices: showPrices,
        redemption_title: redemptionTitle,
        redemption_subheading: redemptionSubTitle,
        redemption_description: redemptionDescription,
        enable_custom_title: enableCustomTitle,
        enable_custom_subheading: Boolean(enableCustomSubTitle),
        enable_custom_description: enableCustomDescription,
        allowed_domains: allowedDomains,
        verify_emails: EmailVerified,
        cardMessage
      }
      console.log(body)
      let response = await gemnoteAPI.put(
        `team/group_orders/${groupOrderDetails.id}`,
        body
      )

      let data = getData(response)
      let groupOrder = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }

      commit(SET_GROUP_ORDER_DETAILS, groupOrder)

      // start auto finalizing if auto finalize toggle is checked
      if (autoFinalize) {
        await dispatch('startInstantFinalize', groupOrder.id)
      }

      // redirect to /group-order-success
      if (redirect) router.push({ name: 'GroupOrderSuccess' })
      if (!redirect) commit(UPDATING_GROUP_ORDER_PASSWORD, false)
    } catch (error) {
      console.log(error)
      if (!redirect) commit(UPDATING_GROUP_ORDER_PASSWORD, true)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-update-error')]
          },
          { root: true }
        )
      }
    }
  },

  async startInstantFinalize({ commit, dispatch }, groupOrderId) {
    try {
      commit(UPDATING_AUTO_FINALIZING, true)
      let response = await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/start_auto_finalize`
      )

      let data = getData(response)
      let groupOrder = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }
      commit(SET_GROUP_ORDER_DETAILS, groupOrder)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.gorder-startautofinalize-error')
            ]
          },
          { root: true }
        )
      }
    } finally {
      commit(UPDATING_AUTO_FINALIZING, false)
    }
  },
  async stopInstantFinalize({ commit, dispatch }, groupOrderId) {
    try {
      commit(UPDATING_AUTO_FINALIZING, true)
      let response = await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/stop_auto_finalize`
      )

      let data = getData(response)
      let groupOrder = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }
      commit(SET_GROUP_ORDER_DETAILS, groupOrder)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.gorder-stopautofinalize-error')
            ]
          },
          { root: true }
        )
      }
    } finally {
      commit(UPDATING_AUTO_FINALIZING, false)
    }
  },
  async uploadGroupOrderCustomBackground(
    { commit, dispatch },
    { storeData, groupOrderId }
  ) {
    try {
      const response = await gemnoteAPI({
        method: 'PATCH',
        url: `team/group_orders/${groupOrderId}`,
        data: storeData,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })
      let data = getData(response)
      let groupOrder = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }
      commit(SET_GROUP_ORDER_DETAILS, groupOrder)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('grouporder.action.gorder-background-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async addTierToGroupOrder({ commit, dispatch }, groupOrderId) {
    try {
      let body = {
        name: '',
        gifts_limit: 1,
        selection_type: 'EXACTLY'
      }

      let response = await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/group_order_tiers`,
        body
      )

      let data = getData(response)
      const defaultTiers = data.attributes.tierItemDetails
      let newTier = {
        id: parseInt(data.id),
        name: data.attributes.name,
        tierQuantityLimit: `${data.attributes.giftsLimit}`,
        tierItems: data.attributes.tierItemDetails,
        defaultTiers: defaultTiers,
        componentType: 'GroupOrderGallery',
        editable: data.attributes['editable?'],
        selectionType: data.attributes.selectionType
      }

      commit(ADD_NEW_TIER_TO_GROUP_ORDER, newTier)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-new-tier-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateGroupOrderTier(
    { commit, dispatch },
    { groupOrderId, tierId, tierQuantityLimit, selectionType, name }
  ) {
    try {
      let errors = []
      if (!tierQuantityLimit) {
        errors.push(i18n.t('validations.enter-valid-gorder-tier-limit'))
      }

      if (errors.length) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        return
      }

      commit(SAVE_TEMP_GROUP_ORDER_TIER, { id: tierId })
      commit(UPDATE_GROUP_ORDER_TIER, {
        id: tierId,
        tierQuantityLimit,
        selectionType,
        name
      })

      let body = {
        name,
        gifts_limit: tierQuantityLimit,
        selection_type: selectionType
      }

      await gemnoteAPI.put(
        `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}`,
        body
      )
    } catch (error) {
      console.log(error)
      commit(RESTORE_TEMP_GROUP_ORDER_TIER, { id: tierId })
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-tier-update-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeTierFromGroupOrder(
    { commit, dispatch },
    { groupOrderId, tierId }
  ) {
    try {
      await gemnoteAPI.delete(
        `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}`
      )

      commit(REMOVE_GROUP_ORDER_TIER, tierId)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: ['Tier deleted successfully.']
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-tier-remove-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addItemToTier(
    { commit, dispatch, state },
    { groupOrderId, tierId, productId, productType }
  ) {
    try {
      let { groupOrderTiers } = state
      // find the tier related to the operation
      let foundTier = groupOrderTiers.find(tier => tier.id === tierId)
      if (!foundTier) {
        // Tier not found
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('validations.group-order-tier-not-found', {
                0: tierId
              })
            ]
          },
          { root: true }
        )
        return
      }

      commit(MARK_TEMPORALY_TIER_ITEM, productId)

      let body = {
        paige_group_order_tiers_item: {
          itemable_id: productId
        }
      }

      let response
      // check for type
      if (productType === 'bundles') {
        response = await gemnoteAPI.post(
          `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/bundle_items`,
          body
        )
      } else {
        response = await gemnoteAPI.post(
          `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/product_items`,
          body
        )
      }

      let data = getData(response)
      let newTierItem = {
        itemId: parseInt(data.id),
        itemableId: productId,
        itemableType: productType === 'products' ? 'Product' : 'Bundle'
      }
      commit(ADD_NEW_ITEM_TO_TIER, { tierId, newTierItem })
    } catch (error) {
      console.log(error)
      commit(CLEAR_TEMPORALY_TIER_ITEMS)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.adding-tier-item-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeItemFromTier(
    { commit, dispatch },
    { groupOrderId, tierId, itemId }
  ) {
    try {
      commit(SAVE_TEMP_ITEM_TO_REMOVE, { tierId, itemId })
      commit(REMOVE_ITEM_FROM_TIER, { tierId, itemId })
      await gemnoteAPI.delete(
        `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/group_order_tier_items/${itemId}`
      )
      commit(CLEAR_TEMP_ITEM_TO_REMOVE)
    } catch (error) {
      console.log(error)
      commit(RESTORE_TEMP_ITEM_TO_REMOVE, { tierId })
      commit(CLEAR_TEMP_ITEM_TO_REMOVE)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.remove-tier-item-error')]
          },
          { root: true }
        )
      }
    }
  },
  async handleMultipleItemTierItems(
    { commit, dispatch },
    { groupOrderId, tierItemsToDelete, itemsToAdd, id, isEdit, isEditable }
  ) {
    try {
      commit(SET_UPDATING_TIER_ITEMS, true)
      if (tierItemsToDelete.length) {
        let errors = []

        let promises = tierItemsToDelete.map(tierItem => {
          let { tierId, itemId } = tierItem
          return new Promise(async (resolve, reject) => {
            try {
              await gemnoteAPI.delete(
                `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/group_order_tier_items/${itemId}`
              )
              return resolve({
                success: true,
                itemId
              })
            } catch (error) {
              console.log(error)
              if (error.response) {
                errors.push(
                  i18n.t('grouporder.action.adding-tier-item-error', {
                    '0': itemId
                  })
                )
                errors.push(error.response.data.errors[0].message)
                return reject(errors)
              } else {
                return reject(errors)
              }
            }
          })
        })

        Promise.all(promises)
          .then(results => {
            console.log(results)
            if (results.every(item => item.success)) {
              commit(SET_UPDATING_TIER_ITEMS, false)
              commit(RESET_TIER_ITEMS_TO_REMOVE)
              commit(SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS, true)

              if (itemsToAdd.length) {
                dispatch('addMultipleItemsToTier', {
                  groupOrderId,
                  itemsToAdd,
                  id,
                  isEdit,
                  isEditable
                })
              } else {
                commit(SET_UPDATING_TIER_ITEMS, false)
                if (isEdit) {
                  if (isEditable) {
                    return router.push({
                      name: 'addCard',
                      params: { id: id, isEdit: isEdit }
                    })
                  } else {
                    return router.push({
                      name: 'EditGroupOrderInfo',
                      params: { id: id, isEdit: true }
                    })
                  }
                } else {
                  router.push({ name: 'addCard', params: { id: id } })
                }
              }
            }
          })
          .catch(errors => {
            commit(SET_UPDATING_TIER_ITEMS, false)
            commit(SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS, false)
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          })
      } else {
        if (itemsToAdd.length) {
          dispatch('addMultipleItemsToTier', {
            groupOrderId,
            itemsToAdd,
            id,
            isEdit,
            isEditable
          })
        } else {
          commit(SET_UPDATING_TIER_ITEMS, false)
          if (isEdit) {
            if (isEditable) {
              return router.push({
                name: 'addCard',
                params: { id: id, isEdit: isEdit }
              })
            } else {
              return router.push({
                name: 'EditGroupOrderInfo',
                params: { id: id, isEdit: true }
              })
            }
          } else {
            router.push({ name: 'addCard', params: { id: id } })
          }
        }
      }
    } catch (error) {
      console.log(error)
      commit(SET_UPDATING_TIER_ITEMS, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.remove-user-exception'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async addMultipleItemsToTier(
    { commit, dispatch, state },
    { groupOrderId, itemsToAdd, id, isEdit, isEditable }
  ) {
    let { groupOrderTiers } = state

    try {
      commit(SET_UPDATING_TIER_ITEMS, true)
      if (itemsToAdd.length) {
        let errors = []

        let promises = itemsToAdd.map(tierItem => {
          let { tierId, productId, productType } = tierItem
          return new Promise(async (resolve, reject) => {
            try {
              // find the tier related to the operation
              let foundTier = groupOrderTiers.find(tier => tier.id === tierId)

              if (!foundTier) {
                // Tier not found
                dispatch(
                  'notification/pushNotification',
                  {
                    type: 'error',
                    messages: [
                      i18n.t('grouporder.action.adding-tier-item-error', {
                        0: tierId
                      })
                    ]
                  },
                  { root: true }
                )
                errors.push(
                  i18n.t('grouporder.action.adding-tier-item-error', {
                    '0': tierId
                  })
                )

                return reject(errors)
              }

              commit(MARK_TEMPORALY_TIER_ITEM, productId)

              let body = {
                paige_group_order_tiers_item: {
                  itemable_id: productId
                }
              }

              let response
              // check for type
              if (productType === 'bundles') {
                response = await gemnoteAPI.post(
                  `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/bundle_items`,
                  body
                )
              } else {
                response = await gemnoteAPI.post(
                  `team/group_orders/${groupOrderId}/group_order_tiers/${tierId}/product_items`,
                  body
                )
              }
              let data = getData(response)
              let newTierItem = {
                itemId: parseInt(data.id),
                itemableId: productId,
                itemableType: productType === 'products' ? 'Product' : 'Bundle'
              }
              commit(ADD_NEW_ITEM_TO_TIER, { tierId, newTierItem })
              return resolve({
                success: true,
                data: newTierItem
              })
            } catch (error) {
              console.log(error)
              if (error.response) {
                commit(SET_UPDATING_TIER_ITEMS, false)
                commit(UNMARK_TEMPORALY_TIER_ITEM, productId)
                commit(REMOVE_ITEM_FROM_TIER, { tierId, itemId: productId })
                commit(CLEAR_TEMPORALY_TIER_ITEMS)

                errors.push(error.response.data.errors[0].message)
                return reject(errors)
              } else {
                errors.push(i18n.t('grouporder.action.adding-tier-item-error'))
                return reject(errors)
              }
            }
          })
        })

        Promise.all(promises)
          .then(results => {
            commit(SET_UPDATING_TIER_ITEMS, false)
            if (results.every(item => item.success)) {
              if (isEdit) {
                if (isEditable) {
                  return router.push({
                    name: 'addCard',
                    params: { id: id, isEdit: isEdit }
                  })
                } else {
                  return router.push({
                    name: 'EditGroupOrderInfo',
                    params: { id: id, isEdit: true }
                  })
                }
              } else {
                router.push({ name: 'addCard', params: { id: id } })
              }
            }
          })
          .catch(errors => {
            commit(SET_UPDATING_TIER_ITEMS, false)
            commit(CLEAR_TEMPORALY_TIER_ITEMS)
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors[0]
              },
              { root: true }
            )
          })
      } else {
        commit(SET_UPDATING_TIER_ITEMS, false)
        if (isEdit) {
          if (isEditable) {
            return router.push({
              name: 'addCard',
              params: { id: id, isEdit: isEdit }
            })
          } else {
            return router.push({
              name: 'EditGroupOrderInfo',
              params: { id: id, isEdit: true }
            })
          }
        } else {
          router.push({ name: 'addCard', params: { id: id } })
        }
      }
    } catch (error) {
      console.log(error)
      commit(SET_UPDATING_TIER_ITEMS, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('team.action.remove-user-exception'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrdersList(
    { commit, dispatch },
    { page = 1, perPage = 50, nameOrEmail, filter }
  ) {
    try {
      commit(LOAD_GROUP_ORDERS_LIST, status.LOADING)
      let response = await gemnoteAPI.get(
        `team/group_orders?page[number]=${page}&page[size]=${perPage}${
          nameOrEmail ? `&search=${nameOrEmail}` : ''
        }&filters[${filter}]=true`
      )
      let { totalCount } = response.data.meta
      let data = getData(response)
      data = data.map(order => {
        return {
          id: order.id,
          createdAt: order.attributes.createdAt,
          uuid: order.attributes.uuid,
          name: order.attributes.name,
          createdBy: order.attributes.createdByUser,
          submissions: order.attributes.submissionsCount,
          status: order.attributes.state,
          isDeletable: order.attributes['deletable?']
        }
      })
      commit(SET_ORDERSTORE_PAGINATION_TOTAL_COUNT, totalCount)
      commit(SET_GROUP_ORDERS_LIST, data.sort(compare))
      commit(LOAD_GROUP_ORDERS_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDERS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-get-list-error')]
          },
          { root: true }
        )
      }
    }
  },
  async deleteGroupOrder({ dispatch }, groupOrderId) {
    try {
      await gemnoteAPI.delete(`team/group_orders/${groupOrderId}`)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: ['Redemption order deleted successfully!']
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-lock-error')]
          },
          { root: true }
        )
      }
    }
  },
  async lockGroupOrder({ commit, dispatch }, groupOrderId) {
    try {
      let response = await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/lock`
      )

      let data = getData(response)
      let groupOrderDetails = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }

      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-lock-error')]
          },
          { root: true }
        )
      }
    }
  },
  async unlockGroupOrder({ commit, dispatch }, groupOrderId) {
    try {
      let response = await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/unlock`
      )

      let data = getData(response)
      let groupOrderDetails = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields
      }

      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-unlock-error')]
          },
          { root: true }
        )
      }
    }
  },
  async finalizeGroupOrder({ commit, dispatch, state }, groupOrderId) {
    let { groupOrderDetails } = state
    try {
      commit(IS_FINALIZING_GROUP_ORDER, true)
      groupOrderDetails.state = 'Validating recipients'
      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)
      await gemnoteAPI.post(
        `team/group_orders/${groupOrderId}/begin_order_processing`
      )
      dispatch('getGroupOrderState', groupOrderId)
      // let groupOrderDetails = {
      //   id: data.id,
      //   ...data.attributes,
      //   password:
      //     data.attributes.password === null ? '' : data.attributes.password,
      //   customFields:
      //     data.attributes.customFields === null
      //       ? []
      //       : data.attributes.customFields
      // }

      commit(IS_FINALIZING_GROUP_ORDER, false)
    } catch (error) {
      console.log(error)
      groupOrderDetails.state = 'pending'
      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)
      commit(IS_FINALIZING_GROUP_ORDER, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-finalize-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrderState({ commit, dispatch }, groupOrderId) {
    try {
      let response = await gemnoteAPI.get(
        `team/group_orders/${groupOrderId}/group_order_state`
      )
      commit(SET_GROUP_ORDER_STATE, response.data)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER_ITEMS_ORDERED, status.LOADING)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-items-ordered-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrderOrderedItems({ commit, dispatch }, groupOrderId) {
    try {
      commit(LOAD_GROUP_ORDER_ITEMS_ORDERED, status.LOADING)
      let response = await gemnoteAPI.get(
        `team/group_orders/${groupOrderId}/items_summary`
      )

      let data = getData(response)
      let itemsOrdered = data.map(item => {
        return {
          id: item.id,
          type: item.type,
          isAccordionActive: false,
          productName: item.attributes && item.attributes.name,
          orderedProductVariants:
            item.type === 'products'
              ? item.attributes && item.attributes.orderedProductVariants
              : item.attributes.orderedProducts,
          redemeedQty: item.attributes && item.attributes.redemeedQty
        }
      })

      // const filteredItems = itemsOrdered.filter(item =>
      //   item.type == 'products' ? item.orderedProductVariants.length : item
      // )

      commit(SET_GROUP_ORDER_ITEMS_ORDERED, itemsOrdered)
      commit(LOAD_GROUP_ORDER_ITEMS_ORDERED, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER_ITEMS_ORDERED, status.LOADING)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-items-ordered-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getGroupOrdersRecipientsList(
    { commit, dispatch },
    { groupOrderId, filterBy, nameOrEmail = '', page = 1, perPage = 50 }
  ) {
    try {
      commit(LOAD_GROUP_ORDER_RECIPIENTS_LIST, status.LOADING)
      commit(CLEAN_RECIPIENTS_LIST_TO_REMOVE)

      let apiRoute = ''
      if (
        recipientListFilterTypes[filterBy] ===
        recipientListFilterTypes.NameOrEmail
      ) {
        apiRoute = `team/group_orders/${groupOrderId}/recipients?filters[name_or_email]=${nameOrEmail}&page[number]=${page}&page[size]=${perPage}`
      } else if (
        recipientListFilterTypes[filterBy] === recipientListFilterTypes.All
      ) {
        apiRoute = `team/group_orders/${groupOrderId}/recipients?page[number]=${page}&page[size]=${perPage}`
      } else {
        apiRoute = `team/group_orders/${groupOrderId}/recipients?filters[${recipientListFilterTypes[filterBy]}]=true&page[number]=${page}&page[size]=${perPage}`
      }

      let response = await gemnoteAPI.get(apiRoute)
      let { totalCount } = response.data.meta
      let data = getData(response)
      data = data.map(recipient => {
        return {
          id: recipient.id,
          ...recipient.attributes,
          customFields:
            recipient.attributes.customFields === null
              ? []
              : recipient.attributes.customFields,
          recipientState:
            recipient.attributes.recipientState === 'disabled'
              ? 'Skipped'
              : recipient.attributes.recipientState === 'finalized'
              ? 'Finalised'
              : recipient.attributes.recipientState === 'locked'
              ? 'Processing'
              : recipient.attributes.recipientState === 'active' &&
                recipient.attributes['groupOrderConfirmed?'] === false
              ? 'Pending'
              : recipient.attributes.recipientState === 'active' &&
                recipient.attributes['groupOrderConfirmed?'] === true
              ? 'Submitted'
              : 'Pending'
        }
      })
      commit(SET_RECIPIENT_PAGINATION, totalCount)
      commit(SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST, data)
      commit(SET_GROUP_ORDER_RECIPIENT_LIST, data)
      commit(LOAD_GROUP_ORDER_RECIPIENTS_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER_RECIPIENTS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-recipient-list-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getRecipientGroupOrderSelectedItems(
    { commit, dispatch },
    groupOrderId
  ) {
    try {
      commit(LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS, status.LOADING)
      let response = await gemnoteAPI.get(
        `team/group_orders/${groupOrderId}/recipient_group_order_tier_items`
      )
      let data = getData(response)
      data = data.map(recipient => {
        return {
          id: recipient.id,
          paigeRecipientId: recipient.attributes.paigeRecipientId,
          selectedVariant:
            recipient.attributes.productVariantAttributes.display_name
        }
      })
      commit(SET_RECIPIENTS_SELECTED_ITEMS, data)
      commit(LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.recipients-selected-items-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async enableDisableGroupOrderRecipient(
    { commit, dispatch, state },
    { groupOrderId, filterBy }
  ) {
    try {
      let { recipientsToSkipOrRemove, groupOrderRecipientsList } = state

      if (recipientsToSkipOrRemove.length) {
        let promises = recipientsToSkipOrRemove.map(recipient => {
          let user = groupOrderRecipientsList.find(
            r => parseInt(r.id) === parseInt(recipient.id)
          )

          if (user.recipientState === 'Skipped') {
            return new Promise(async (resolve, reject) => {
              try {
                await gemnoteAPI.post(
                  `team/group_orders/${groupOrderId}/recipients/${user.id}/enable`
                )

                return resolve({
                  id: user.id
                })
              } catch (error) {
                console.log(error)
                if (error.response) {
                  let { errors } = error.response.data
                  return reject(errors)
                } else {
                  return reject(
                    i18n.t('grouporder.action.skip-gorder-recipient')
                  )
                }
              }
            })
          } else {
            return new Promise(async (resolve, reject) => {
              try {
                await gemnoteAPI.post(
                  `team/group_orders/${groupOrderId}/recipients/${user.id}/disable`
                )

                return resolve({
                  id: user.id
                })
              } catch (error) {
                console.log(error)
                if (error.response) {
                  let { errors } = error.response.data
                  return reject(errors)
                } else {
                  return reject(
                    i18n.t('grouporder.action.skip-gorder-recipient')
                  )
                }
              }
            })
          }
        })

        Promise.all(promises)
          .then(results => {
            console.log(results)
            commit(CLEAN_RECIPIENTS_LIST_TO_REMOVE)
            dispatch('getGroupOrdersRecipientsList', {
              groupOrderId,
              filterBy
            })
          })
          .catch(errors => {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          })
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.no-selected-recipients-to-skipped')
            ]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.skip-gorder-recipient')]
          },
          { root: true }
        )
      }
    }
  },
  addRecipientToBeSkippedOrRemovedFromGO({ commit }, id) {
    commit(ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO, id)
  },
  async removeRecipientsFromGroupOrder(
    { commit, dispatch, state },
    groupOrderId
  ) {
    try {
      let { recipientsToSkipOrRemove } = state

      if (recipientsToSkipOrRemove.length) {
        let promises = recipientsToSkipOrRemove.map(user => {
          let { id } = user
          return new Promise(async (resolve, reject) => {
            try {
              await gemnoteAPI.delete(
                `team/group_orders/${groupOrderId}/recipients/${id}`
              )
              return resolve({
                success: true,
                id
              })
            } catch (error) {
              console.log(error)
              if (error.response) {
                let { errors } = error.response.data
                return reject(errors[0].message)
              } else {
                return reject(
                  i18n.t('grouporder.action.remove-gorder-recipient')
                )
              }
            }
          })
        })

        Promise.all(promises)
          .then(results => {
            let userIdsToRemove = results.map(result => result.id)
            userIdsToRemove.forEach(id => {
              commit(REMOVE_RECIPIENT_FROM_GROUP_ORDER, id)
            })
            commit(CLEAN_RECIPIENTS_LIST_TO_REMOVE)
          })
          .catch(errors => {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          })
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.no-selected-recipients-to-remove')
            ]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('grouporder.action.remove-gorder-recipient'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  // Public apis for recipient flow
  async getGroupOrderPublicInfo({ commit, dispatch }, uuid) {
    try {
      if (!uuid) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.group-order-uid-required')]
          },
          { root: true }
        )
        commit(LOAD_GROUP_ORDER_INFO, status.LOADED)
        commit(SET_GROUP_ORDER_DETAILS, {})
        return
      }

      commit(LOAD_GROUP_ORDER_INFO, status.LOADING)
      let response = await gemnoteAPI.get(`group_orders/${uuid}`)
      let data = getData(response)
      let groupOrderDetails = {
        id: data.id,
        ...data.attributes,
        password:
          data.attributes.password === null ? '' : data.attributes.password,
        customFields:
          data.attributes.customFields === null
            ? []
            : data.attributes.customFields,
        customBackground:
          data.attributes.customBackground === null
            ? {}
            : data.attributes.customBackground,
        teamLogo:
          data.attributes.teamLogo === null ? {} : data.attributes.teamLogo
      }
      commit(SET_GROUP_ORDER_DETAILS, groupOrderDetails)
      commit(LOAD_GROUP_ORDER_INFO, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(SET_GROUP_ORDER_DETAILS, {})
      commit(LOAD_GROUP_ORDER_INFO, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-info-error')]
          },
          { root: true }
        )
      }
    }
  },

  async validateGroupOrderRecipient(
    { commit, dispatch },
    { email, password, uuid, resend }
  ) {
    try {
      if (email.trim() === '') {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.blank-email')]
          },
          { root: true }
        )
        return
      }

      commit(VALIDATING_GROUP_ORDER_RECIPIENT, true)
      const response = await gemnoteAPI.post(
        `recipients/${uuid}/send_verification_email`,
        {
          email,
          password
        }
      )

      const data = response.data

      if (data.verified) {
        // Log user in => call the create recipient function
        dispatch('createRecipient', { email, password, uuid })
      }

      if (resend) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: ['Verification email resent successfully!']
          },
          { root: true }
        )
      }

      commit(VERIFICATION_EMAIL_STATUS, data.verification_email_sent)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)
    } catch (error) {
      console.log(error)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          const data = error.response && error.response.data
          let { errors, message } = data

          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors ? [errors[0].message] : [message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },

  async verifyGroupOrderRecipient({ commit, dispatch }, { uuid, token }) {
    try {
      commit(REDEMPTION_UUID, uuid)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, true)

      const response = await gemnoteAPI.post(`recipients/${uuid}/verify`, {
        token
      })

      const { email, password, verified } = response.data

      if (verified) {
        // Log user in => call the create recipient function
        await dispatch('createRecipient', {
          email,
          password,
          uuid,
          verified
        })
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.invalid-verification-code')]
          },
          { root: true }
        )

        setTimeout(() => {
          window.close()
        }, 3000)
      }
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)
    } catch (error) {
      console.log(error)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },

  async createRecipient(
    { commit, dispatch, state },
    { email, password, uuid, verified }
  ) {
    try {
      let body = {
        recipient: {
          email
        },
        password
      }

      let response = await gemnoteAPI.post(`recipients/${uuid}`, body)
      let data = getData(response)

      let recipientSession = {
        id: data.id,
        email,
        uuid
      }

      window.$cookies.remove('recipient-session')
      window.$cookies.set('recipient-session', recipientSession)

      let { groupOrderDetails } = state
      let groupOrderCustomFields = []
      const fields = (groupOrderDetails && groupOrderDetails.customFields) || []

      // go loop for custom fields created on the group order
      for (let index = 0; index < fields.length; index++) {
        const field = fields[index]
        groupOrderCustomFields.push({ ...field, value: '' })
      }

      // check if recipient already set info for custom fields, in that case we map thru to set the current value
      if (data.attributes.customFields) {
        data.attributes.customFields.forEach(field => {
          let fieldIndex = groupOrderCustomFields.findIndex(
            cfield => cfield.name == field.name
          )
          if (fieldIndex >= 0) {
            groupOrderCustomFields[fieldIndex].value = field.value
          }
        })
      }

      // set recipient object without the custom fields that came from recipients, we in fact send the recent builded groupOrderCustomFields
      let { attributes } = data
      let recipient = {
        id: data.id,
        ...attributes,
        customFields: groupOrderCustomFields
      }

      commit(SET_GROUP_ORDER_RECIPIENT, recipient)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)

      const finalizedStates = ['locked', 'finalized']

      if (
        recipient['groupOrderConfirmed?'] &&
        recipient.recipientState === 'active'
      ) {
        await dispatch('getRecipientSelectedItems')
        commit(CONFIRM_RECIPIENT_GROUP_ORDER)
        router.push({ name: 'RecipientSuccessGroupOrder' })
      } else if (finalizedStates.includes(recipient.recipientState)) {
        await dispatch('getRecipientSelectedItems')
        commit(CONFIRM_RECIPIENT_GROUP_ORDER)
        router.push({ name: 'RecipientSuccessGroupOrder' })
      } else if (recipient.recipientState === 'active') {
        if (verified) {
          router.push({
            name: 'EmailVerificationSuccess',
            params: {
              logo:
                groupOrderDetails &&
                groupOrderDetails.teamLogo &&
                groupOrderDetails.teamLogo.url,
              name: groupOrderDetails.name,
              redirect: 'GroupOrderTierList'
            }
          })
        } else {
          router.push({ name: 'GroupOrderTierList' })
        }
      } else {
        return
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },
  async createOktaRecipient({ commit, dispatch, state }, data) {
    try {
      let recipientSession = {
        id: data.id,
        email: data.email,
        uuid: data.id
      }

      window.$cookies.remove('recipient-session')
      window.$cookies.set('recipient-session', recipientSession)

      let { groupOrderDetails } = state

      let groupOrderCustomFields = []
      const fields = (groupOrderDetails && groupOrderDetails.customFields) || []

      // go loop for custom fields created on the group order
      for (let index = 0; index < fields.length; index++) {
        const field = fields[index]
        groupOrderCustomFields.push({ ...field, value: '' })
      }

      // check if recipient already set info for custom fields, in that case we map thru to set the current value
      if (data.custom_fields) {
        data.custom_fields.forEach(field => {
          let fieldIndex = groupOrderCustomFields.findIndex(
            cfield => cfield.name == field.name
          )
          if (fieldIndex >= 0) {
            groupOrderCustomFields[fieldIndex].value = field.value
          }
        })
      }

      // set recipient object without the custom fields that came from recipients, we in fact send the recent builded groupOrderCustomFields
      let recipient = {
        ...data,
        customFields: groupOrderCustomFields
      }

      commit(SET_GROUP_ORDER_RECIPIENT, recipient)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)

      const finalizedStates = ['locked', 'finalized']

      if (
        recipient['group_order_confirmed'] &&
        recipient.recipient_state === 'active'
      ) {
        await dispatch('getRecipientSelectedItems')
        commit(CONFIRM_RECIPIENT_GROUP_ORDER)
        router.push({ name: 'RecipientSuccessGroupOrder' })
      } else if (finalizedStates.includes(recipient.recipient_state)) {
        await dispatch('getRecipientSelectedItems')
        commit(CONFIRM_RECIPIENT_GROUP_ORDER)
        router.push({ name: 'RecipientSuccessGroupOrder' })
      } else if (recipient.recipient_state === 'active') {
        router.push({ name: 'GroupOrderTierList' })
      } else {
        return
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },

  async getRecipientGroupOrderTiers({ commit, dispatch, state }) {
    try {
      commit(LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT, status.LOADING)
      let uuid = state.groupOrderDetails.uuid
      let response = await gemnoteAPI.get(
        `recipients/${uuid}/group_order_tiers`
      )
      let data = getData(response)
      let selectableTiers = data.map(tier => {
        return {
          id: tier.id,
          name: tier.attributes.name,
          giftsLimit: tier.attributes.giftsLimit,
          tierDetails: tier.attributes.tierItemDetails.length
            ? tier.attributes.tierItemDetails
            : [],
          // selectionType: 'UPTO',
          selectionType: tier.attributes.selectionType
            ? tier.attributes.selectionType
            : 'UPTO',
          showPrices: response.data.included
            ? response.data.included[0].attributes.showPrices
            : true
        }
      })
      commit(SET_SELECTABLE_GROUP_ORDER_TIERS, selectableTiers)

      // GET current selected items
      await dispatch('getRecipientSelectedItems')
      commit(LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.get-recipient-gorder-tiers-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async getRecipientSelectedItems({ commit, dispatch, state }) {
    try {
      let uuid = state.groupOrderDetails.uuid
      let { recipient } = state
      let response = await gemnoteAPI.get(
        `recipients/${uuid}/items?recipient_id=${recipient.id}`
      )
      let data = getData(response)
      let selectedItems = data.map(item => {
        return {
          id: item.id,
          productId: item.attributes.productId,
          productVariantId: item.attributes.productVariantId,
          tierId: item.attributes.paigeGroupOrderTierId,
          productVariantAttributes: {
            productName: item.attributes.productVariantAttributes.product_name,
            spec: item.attributes.productVariantAttributes.spec,
            representative_images: item.attributes.productVariantAttributes
              .representative_images.length
              ? item.attributes.productVariantAttributes
                  .representative_images[0].url
              : defaultNotFoundImage
          },
          bundleId: item.attributes.bundleId,
          productVariantQty: item.attributes.productVariantQty
        }
      })
      commit(SET_CURRENT_ITEMS_SELECTED, selectedItems)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.recipient-selected-items-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async handleReceipientSelection(
    { dispatch, state },
    { payload, recipientId }
  ) {
    try {
      const uuid = state.groupOrderDetails.uuid
      const data = []

      // Sort Items Here
      payload.forEach(product => {
        const variants = []

        if (product.type === 'bundle') {
          product.items.forEach(variant => {
            variants.push({
              bundle_id: product.bundleId,
              product_variant_id: variant.variantId,
              group_order_tier_id: parseInt(product.tierId)
            })
          })
        }

        if (product.type === 'product') {
          variants.push({
            product_variant_id: product.variantId,
            group_order_tier_id: parseInt(product.tierId)
          })
        }

        variants.map(item => data.push(item))
      })

      const checkAllItems = data.every(item => item.product_variant_id)

      if (checkAllItems) {
        const response = await gemnoteAPI.post(`recipients/${uuid}/items`, {
          recipients_group_order_tier_item: data,
          recipient_id: parseInt(recipientId)
        })

        if (response.status === 200) {
          localStorage.setItem(
            `groupOrderPayload${recipientId}`,
            JSON.stringify(payload)
          )
          router.push({ name: 'GroupOrderRecipientForm' })
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.recipient-select-item-error')]
          },
          { root: true }
        )
      }
    }
  },

  persistVariant({ commit }, payload) {
    commit(HANDLE_VARIANT_SELECTION, payload)
  },
  async recipientSelectItem(
    { commit, dispatch, state },
    {
      productVariantId,
      groupOrderTierId,
      bundleId = null,
      itemId = null,
      variant
    }
  ) {
    let randomId = Math.random()
      .toString(20)
      .substr(2, 7)

    try {
      let newSelectedItem = {
        id: randomId,
        productId: variant.product_id,
        productVariantId: variant.id,
        tierId: groupOrderTierId,
        productVariantAttributes: {
          productName: variant.product_name,
          spec: variant.spec,
          representative_images: variant.representative_images.length
            ? variant.representative_images[0].url
            : defaultNotFoundImage
        },
        bundleId
      }
      commit(ADD_NEW_ITEM_TO_RECIPIENT_SELECTION, newSelectedItem)

      let { recipient } = state
      let uuid = state.groupOrderDetails.uuid
      let body

      if (bundleId) {
        body = {
          recipients_group_order_tier_item: {
            product_variant_id: productVariantId,
            group_order_tier_id: groupOrderTierId,
            bundle_id: bundleId
          },
          recipient_id: recipient.id
        }
      } else {
        body = {
          recipients_group_order_tier_item: {
            product_variant_id: productVariantId,
            group_order_tier_id: groupOrderTierId
          },
          recipient_id: recipient.id
        }
      }

      let response = await gemnoteAPI.post(`recipients/${uuid}/items`, body)
      let data = getData(response)
      let realId = data.id
      commit(SET_REALID_TO_ITEM_RECIPIENT_SELECTION, { realId, randomId })

      if (bundleId) {
        dispatch('deactivateItem', {
          tierId: groupOrderTierId,
          id: bundleId
        })
      } else {
        dispatch('deactivateItem', {
          tierId: groupOrderTierId,
          id: itemId
        })
      }
    } catch (error) {
      console.log(error)
      if (randomId) commit(REMOVE_TEMP_ITEM_RECIPIENT_SELECTION, randomId)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.recipient-select-item-error')]
          },
          { root: true }
        )
      }
    }
  },
  async recipientRemoveItem({ commit, dispatch, state }, itemId) {
    try {
      let uuid = state.groupOrderDetails.uuid
      commit(SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION, itemId)
      commit(REMOVE_ITEM_FROM_RECIPIENT_SELECTION, itemId)
      await gemnoteAPI.delete(`recipients/${uuid}/items/${itemId}`)
      commit(CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
    } catch (error) {
      console.log(error)
      commit(RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
      commit(CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.recipient-remove-selection-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async removeThenAddItem(
    { commit, dispatch, state },
    { productVariantId, groupOrderTierId, bundleId, itemId, variant }
  ) {
    let randomId = Math.random()
      .toString(20)
      .substr(2, 7)

    try {
      let uuid = state.groupOrderDetails.uuid
      let { recipient } = state
      let body, newSelectedItem

      if (bundleId) {
        body = {
          recipients_group_order_tier_item: {
            product_variant_id: productVariantId,
            group_order_tier_id: groupOrderTierId,
            bundle_id: bundleId
          },
          recipient_id: recipient.id
        }

        // first remove item using current actions
        commit(SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION, itemId)
        commit(REMOVE_ITEM_FROM_RECIPIENT_SELECTION, itemId)
        await gemnoteAPI.delete(`recipients/${uuid}/items/${itemId}`)
        commit(CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)

        // then add new item selected
        newSelectedItem = {
          id: randomId,
          productId: variant.product_id,
          productVariantId: variant.id,
          tierId: groupOrderTierId,
          productVariantAttributes: {
            productName: variant.product_name,
            spec: variant.spec,
            representative_images: variant.representative_images.length
              ? variant.representative_images[0].url
              : defaultNotFoundImage
          },
          bundleId
        }
        commit(ADD_NEW_ITEM_TO_RECIPIENT_SELECTION, newSelectedItem)
      } else {
        body = {
          recipients_group_order_tier_item: {
            product_variant_id: productVariantId,
            group_order_tier_id: groupOrderTierId
          },
          recipient_id: recipient.id
        }

        // first add item to selected items
        newSelectedItem = {
          id: randomId,
          productId: variant.product_id,
          productVariantId: variant.id,
          tierId: groupOrderTierId,
          productVariantAttributes: {
            productName: variant.product_name,
            spec: variant.spec,
            representative_images: variant.representative_images.length
              ? variant.representative_images[0].url
              : defaultNotFoundImage
          },
          bundleId
        }
        commit(ADD_NEW_ITEM_TO_RECIPIENT_SELECTION, newSelectedItem)

        // then remove the item
        commit(SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION, itemId)
        commit(REMOVE_ITEM_FROM_RECIPIENT_SELECTION, itemId)
        await gemnoteAPI.delete(`recipients/${uuid}/items/${itemId}`)
        commit(CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
      }

      let response = await gemnoteAPI.post(`recipients/${uuid}/items`, body)
      let data = getData(response)
      let realId = data.id
      commit(SET_REALID_TO_ITEM_RECIPIENT_SELECTION, { realId, randomId })
    } catch (error) {
      console.log(error)
      commit(RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
      commit(CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION)
      if (randomId) commit(REMOVE_TEMP_ITEM_RECIPIENT_SELECTION, randomId)

      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.recipient-remove-add-item')]
          },
          { root: true }
        )
      }
    }
  },
  async recipientRemoveBundleItems(
    { commit, dispatch, state },
    { selectedBundleItems, bundleId, tierId }
  ) {
    try {
      let uuid = state.groupOrderDetails.uuid
      commit(SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION, { bundleId, tierId })
      commit(REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION, { bundleId, tierId })

      let promises = selectedBundleItems.map(item => {
        return new Promise(async (resolve, reject) => {
          try {
            await gemnoteAPI.delete(`recipients/${uuid}/items/${item}`)
            return resolve({ success: true })
          } catch (error) {
            if (error.response) {
              let { errors } = error.response.data
              return reject(
                i18n.t('grouporder.action.recipient-remove-bundle-error', {
                  0: item,
                  1: errors[0].message
                })
              )
            } else {
              return reject(
                i18n.t('grouporder.actio.recipient-remove-bundle-exception')
              )
            }
          }
        })
      })

      Promise.all(promises)
        // eslint-disable-next-line no-unused-vars
        .then(async result => {
          commit(CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION)
        })
        .catch(error => {
          commit(RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION)
          commit(CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION)
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [error]
            },
            { root: true }
          )
        })
    } catch (error) {
      console.log(error)
      commit(RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION)
      commit(CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.recipient-remove-selection-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async updateRecipientInfo({ commit, dispatch, state }) {
    try {
      commit(UPDATING_GROUP_ORDER_RECIPIENT, true)
      let uuid = state.groupOrderDetails.uuid
      let recipient = state.recipient
      let body = {
        recipient: {
          name: recipient.name,
          company: recipient.company,
          email: recipient.email,
          phone: recipient.phone,
          address_one: recipient.addressOne,
          address_two: recipient.addressTwo,
          city: recipient.city,
          state: recipient.state,
          zipcode: recipient.zipcode,
          country: recipient.country,
          custom_fields: recipient.customFields
        }
      }

      let response = await gemnoteAPI.put(
        `recipients/${uuid}/${recipient.id}`,
        body
      )
      let data = getData(response)
      commit(SET_GROUP_ORDER_RECIPIENT, {
        id: data.id,
        ...data.attributes
      })

      commit(UPDATING_GROUP_ORDER_RECIPIENT, false)
      router.push({ name: 'GroupOrderConfirmation' })
    } catch (error) {
      console.log(error)
      commit(UPDATING_GROUP_ORDER_RECIPIENT, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.recipient-update-info-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getRecipientShippingDetails(
    { commit, dispatch },
    { groupOrderId, token }
  ) {
    try {
      commit(GETTING_SHIPPING_DETAILS, true)
      const response = await gemnoteAPI.get(
        `/recipients/${groupOrderId}/${token}`
      )
      if (response.status === 200) {
        let data = getData(response).attributes
        let id = getData(response).id
        let body = {
          recipient: {
            name: data.deliveryName,
            company: data.company,
            email: data.deliveryEmail,
            phone: data.deliveryPhone,
            addressOne: data.deliveryAddressOne,
            addressTwo: data.deliveryAddressTwo,
            city: data.deliveryCity,
            state: data.deliveryState,
            zipcode: data.deliveryZipcode,
            country: data.deliveryCountry,
            trackingUrl: data.trackingUrl,
            trackingNumber: data.trackingNumber
          }
        }
        let selectedItems = response.data.included.map(item => {
          return {
            id: item.id,
            productId: item.attributes.productId,
            productVariantId: item.relationships.productVariant.data.id,
            // tierId: item.attributes.paigeGroupOrderTierId,
            productVariantAttributes: {
              productName: item.attributes.displayName,
              spec: { size: item.attributes.size },
              representative_images: item.attributes.representativeImages.length
                ? item.attributes.representativeImages[0].url
                : defaultNotFoundImage
            },
            bundleId: item.attributes.bundleId,
            productVariantQty: item.attributes.productVariantQty
          }
        })
        commit(SET_CURRENT_ITEMS_SELECTED, selectedItems)
        commit(SET_GROUP_ORDER_RECIPIENT, {
          id: id,
          ...body
        })
      }
      commit(GETTING_SHIPPING_DETAILS, false)
    } catch (error) {
      console.log(error)
      commit(GETTING_SHIPPING_DETAILS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.recipient-update-info-error')]
          },
          { root: true }
        )
      }
    }
  },
  async confirmRecipientGroupOrder({ commit, dispatch, state }) {
    try {
      let uuid = state.groupOrderDetails.uuid
      let recipient = state.recipient

      commit(IS_CONFIRMING_GROUP_ORDER, true)

      await gemnoteAPI.post(`recipients/${uuid}/${recipient.id}/confirm`)

      commit(CONFIRM_RECIPIENT_GROUP_ORDER)
      commit(IS_CONFIRMING_GROUP_ORDER, false)

      router.push({ name: 'RecipientSuccessGroupOrder' })

      commit(HANDLE_VARIANT_SELECTION, {})
      localStorage.removeItem('bundleVariant')
      localStorage.removeItem(`groupOrderPayload${recipient.id}`)
    } catch (error) {
      console.log(error)
      let errors = []
      commit(IS_CONFIRMING_GROUP_ORDER, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('grouporder.action.recipient-confirm-order-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  activateItem({ commit }, { tierId, id }) {
    commit(ACTIVATE_ITEM, { tierId, id })
  },
  deactivateItem({ commit }, { tierId, id }) {
    commit(DEACTIVATE_ITEM, { tierId, id })
  },
  resetGroupOrderState({ commit }) {
    commit(RESET_GROUP_ORDER_STATE)
  }
}
